import DonneeFiltreesController from './donnee.filtrees.controller';

export default {
    template: require('./donnee.filtrees.html'),
    controller: DonneeFiltreesController
};
